<script>import Play from './MediaControlsIcon/MediaControlsIconPlay.svelte';
import Pause from './MediaControlsIcon/MediaControlsIconPause.svelte';
import Reset from './MediaControlsIcon/MediaControlsIconReset.svelte';
export let as = 'button';
export let isPlaying = true;
export let isCompleted = false;
export let useAriaLabel = true;
export let onClick = () => { };
function handleClick() {
    onClick();
}
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
  this={as}
  {...$$restProps}
  class="MediaControls {$$restProps.class || ''}"
  {...useAriaLabel ? { 'aria-label': isCompleted ? 'Reset' : isPlaying ? 'Pause' : 'Play' } : {}}
  on:click={handleClick}
>
  {#if isCompleted}
    <Reset />
  {:else if isPlaying}
    <Pause />
  {:else}
    <Play />
  {/if}
</svelte:element>

<style>.MediaControls {
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--media-controls-height);
  width: var(--media-controls-width);
  background-color: var(--media-controls-background-color-default);
  border-radius: 100%;
  transition: transform var(--duration-quick) var(--easing-decelerate);
}
.MediaControls:focus-visible:not(:active) {
  outline: var(--accessibility-focus-outline-width) var(--accessibility-focus-outline-style, solid) var(--accessibility-focus-outline-color);
  border-radius: 100%;
  outline-offset: var(--accessibility-focus-outline-offset);
}
.MediaControls:active {
  transform: translateY(var(--media-controls-active-translate-y)) scale(var(--media-controls-active-scale));
}
.MediaControls :global(svg) {
  fill: var(--media-controls-icon-color-default);
}
.MediaControls :global(svg.MediaControlsIconPlay) {
  height: var(--media-controls-icon-play-height);
  width: var(--media-controls-icon-play-width);
}</style>
